import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Label } from '../../../../components/styled/global.style'
import { FormError, InputBaseStyle, TextFieldStyle } from '../../Trade.style'

const EnhancedReverseOptionTrade = ({
  form,
  handelDateChange,
  handelFormChange,
  disabled = false,
  errors
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Spot Ref *</Label>
        <InputBaseStyle
          name="spot_ref"
          placeholder="0.00"
          value={form.spot_ref}
          disabled={disabled}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Window Start *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_start}
          myerror={String(!!errors.window_start)}
          disabled={disabled}
          onChange={event => handelDateChange('window_start', event.target.value)}
        />
        {errors.window_start && <FormError>{errors.window_start}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Window End *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          disabled={disabled}
          value={form.window_end}
          onChange={event => handelDateChange('window_end', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Barrier *</Label>
        <InputBaseStyle
          name="barrier"
          placeholder="0.00"
          value={form.barrier}
          disabled={disabled}
          onChange={handelFormChange}
        />
      </Box>
    </>
  )
}

export default EnhancedReverseOptionTrade

EnhancedReverseOptionTrade.propTypes = {
  disabled: PropTypes.bool,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  form: PropTypes.object,
  errors: PropTypes.object
}
